
export default {
props:{
  banner:[],
  height:String,
}
};
